import '../stylesheets/application.scss';

import Sittercity from '../core/sittercity';
import App from '../apps/App.vue';
import { setupApollo } from '../lib/apollo_setup';
import { installGoogleMapsVuePlugin } from '../lib/installGoogleMapsVuePlugin';

import router from '../router';
import store from '../store';

export const apolloProvider = setupApollo();

document.addEventListener('DOMContentLoaded', async () => {
  const appNode = document.getElementById('app');

  if (appNode === null) {
    console.log('Continuing to entrypoints'); // eslint-disable-line no-console
  } else {
    appNode.innerHTML = '<div style="text-align: center; padding: 50px; font-size: 18px;">Loading...</div>';

    try {
      await installGoogleMapsVuePlugin();
    } catch (error) {
      console.warn('Google Maps Vue plugin setup failed:', error);
    }

    try {
      await store.dispatch('account/fetchAccountData');
    } catch (error) {
      console.error('Failed to fetch account data', error);
    }

    new Sittercity({
      router,
      store,
      apolloProvider,
      name: 'Sittercity',
      render(createElement) {
        return createElement(App);
      },
    }).$mount('#app');
  }
});
